<a *ngIf="!isAbandoned || hasReadAccess" (click)="onDashboardClick($event)" [ngbPopover]="params.value" container="body" 
    popoverClass="CXoneMgtPopover" placement="bottom-left top-left" triggers="mouseenter:mouseleave" 
    [disablePopover]="params.value === null || params.value === ''" class="textContent">
    <div class="nameText" *ngIf="value" [innerHTML]="value | boldText:searchFilter:minSearchLength"></div>
</a>
<div *ngIf="isAbandoned && !hasReadAccess">
    <span *ngIf="value">{{ value }}</span>
    <i *ngIf="!value" cvLocalizedText langSection="Dashboards_Landing" langKey="No_Name">No Name</i>
</div>